import { render } from "./EnviarNotificacao.vue?vue&type=template&id=07d76de2"
import script from "./EnviarNotificacao.vue?vue&type=script&lang=js"
export * from "./EnviarNotificacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__